import { Component, ChangeDetectionStrategy } from '@angular/core';

import { AuthenticationService } from '../../../user/services/authentication.service';

@Component({
  selector: 'ngx-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LogoutComponent {
  constructor(private auth: AuthenticationService) {}

  logout() {
    this.auth.logout();
  }
}
